import * as React from "react";
import ShoppingBasketStore from "../../stores/ShoppingBasketStore";
import {CartViewer} from "./CartViewer";
import {Checkout} from "./Checkout";
import {CartBlackoutZones} from "./CartBlackoutZones";
import {MoneyDisplay} from "../common/MoneyDisplay";
import {ShoppingBasket as ShoppingBasketModel} from "../../models/ShoppingBasket";
import {ShoppingBasketLineItem} from "../../models/ShoppingBasketLineItem";
import {ModalDialog, ModalBody, ModalFooter } from "../common/ModalDialog";
import {Button } from "../common/Button";
import update = require("react-addons-update");
require("../../styles/Emanager.scss");
import FBEmitter = require("fbemitter");
export interface ShoppingBasketProps
{
	allowLineItemEdits?: boolean;
	showShipping?: boolean;
	hidePONumber?: boolean;
	cartTitle?: string;
	lockShippingAddress?: boolean;
	shippingRequiresPhoneNumber?: boolean;
	billingRequiresPhoneNumber?: boolean;
	termsLink?: string;
	onCheckoutSuccess?: (orderId: string) => void;
	skipRedirectToOrderConfirmation?: boolean;
	isMiniMode?: boolean;
	disableLogonCheck?: boolean;
}

export interface ShoppingBasketState
{
	shoppingBasket: ShoppingBasketModel;
	isRemoveItemDialogOpen: boolean;
	isLogonCheckDialogOpen: boolean;
	isCheckingout: boolean;
	productErrors: string;
	isErrorDialogOpen:boolean;
	removingLineItem?: ShoppingBasketLineItem;
}

export class ShoppingBasket extends React.Component<ShoppingBasketProps, ShoppingBasketState>
{
	private basketLoaderSubscription: FBEmitter.EventSubscription;
	state: ShoppingBasketState =
	{
		shoppingBasket: null,
		isRemoveItemDialogOpen: false,
		isLogonCheckDialogOpen: false,
		isCheckingout: false,
		productErrors:"",
		isErrorDialogOpen:false
	};

	static defaultProps: ShoppingBasketProps = {
		allowLineItemEdits: true,
		showShipping: true,
		cartTitle: "Shopping Cart",
		lockShippingAddress: false,
		skipRedirectToOrderConfirmation: false,
		disableLogonCheck: false
	};

	constructor(props: ShoppingBasketProps, context: any)
	{
		super(props, context);
		if (this.props.disableLogonCheck)
			ShoppingBasketStore.loadBasketFromServer();
		else if (ShoppingBasketStore.logonDataPasses())
			ShoppingBasketStore.loadBasketFromServer();
	}

	componentDidMount()
	{
		this.basketLoaderSubscription = ShoppingBasketStore.addListener(this.basketUpdated.bind(this));
	}

	componentDidUnMount()
	{
		this.basketLoaderSubscription.remove();
	}

	private basketUpdated()
	{
		if (ShoppingBasketStore.invalidCustomerBasket())
		{
			ShoppingBasketStore.reloadInvalidBasket();
			return;
		}
		var basket = ShoppingBasketStore.getBasket();
		var email = window.username;
		if (email && email !== "")
		{
			var customer = basket.customer;
			if (customer.emailAddress.toLocaleLowerCase() !== email.toLocaleLowerCase())
				ShoppingBasketStore.setEmailAddressForAnon(email);
		}
		var errors = ShoppingBasketStore.getErrors();
		if (errors === "")
			this.setState(update(this.state, { $set: { "shoppingBasket": basket} }));
		else if (errors !== "" && !this.state.isErrorDialogOpen)
		{
			this.setState(update(this.state, { $set: { "productErrors": errors, "isErrorDialogOpen":true } }));
			ShoppingBasketStore.loadBasketFromServer();
		}
	}

	private confirmRemoveLineItem(lineItem: ShoppingBasketLineItem)
	{
		this.setState(update(this.state, { $set: { removingLineItem: lineItem } }));
		this.showRemoveItemDialog(true);
	}

	private removeLineItem()
	{
		if (this.state.removingLineItem)
		{
			const sku = this.state.removingLineItem.sku;
			this.showRemoveItemDialog(false);
			setTimeout(() =>
			{
				this.setState(update(this.state, { $set: { removingLineItem: null } }));
				ShoppingBasketStore.setLineItemQuantity(sku, 0);
			},
				0);
		}
	}

	private redirectToLogon()
	{
		window.location.href = window.location.protocol +
			"//" +
			window.location.host +
			"/logon.htm?ReturnUrl=%2f" +
			window.location.pathname.substring(1);
	}

	private showRemoveItemDialog(state: boolean)
	{
		this.setState(update(this.state, { $set: { isRemoveItemDialogOpen: state } }));
	}

	private showLoginPromptDialog(state: boolean)
	{
		this.setState(update(this.state, { $set: { isLogonCheckDialogOpen: state } }));
	}

	private closeErrorDialog()
	{
		this.setState(update(this.state, { $set: { isErrorDialogOpen: false,productErrors:"" } }));
	}

	private adjustLineItemQty(lineItem: ShoppingBasketLineItem, qty: number)
	{
		if (isNaN(qty))
		{
			return;
		}
		if (qty === 0)
		{
			this.confirmRemoveLineItem(lineItem);
			return;
		}
		ShoppingBasketStore.setLineItemQuantity(lineItem.sku, qty);
	}

	private openRemoveItemDialog()
	{
		return true;
	}

	private gotoCheckout()
	{
		this.checkLoginStatus();
	}

	private checkLoginStatus()
	{
		if (this.state.shoppingBasket.configuration.isAnonymousCheckoutEnabled)
		{
			this.setState(update(this.state, { $set: { isCheckingout: true } }));
			return;
		}
		var isLoggedOut = window.username === "" || !window.username;
		if (isLoggedOut)
		{
			this.showLoginPromptDialog(true);
		} else
		{
			this.setState(update(this.state, { $set: { isCheckingout: true } }));
		}
	}

	render()
	{
		
		if (this.props.isMiniMode)
		{
			if (this.state.shoppingBasket === null || this.state.shoppingBasket === undefined)
				{
					return <a href="/shoppingbasket.htm" title="Cart" className="header-checkout">
						<i className="fa fa-shopping-cart" aria-hidden="true">&nbsp;</i> 
						<span className="hidden-xs">Cart</span>
					</a>;
				}
			return <a href="/shoppingbasket.htm" title="Cart" className="header-checkout">
						<i className="fa fa-shopping-cart" aria-hidden="true">&nbsp;</i> 
						<span className="hidden-xs">Cart <MoneyDisplay amount={this.state.shoppingBasket.grandTotal}/></span>
					</a>;
				
		}
		if (this.state.shoppingBasket === null || this.state.shoppingBasket === undefined)
			{
				return <div>
					<h1>Loading Shopping Cart...</h1>
				</div>;
			}
		return <div>
			{this.renderShoppingBasket() }
			{this.renderCheckout() }
			{this.renderRemoveItemDialog() }
			{this.renderLoginPromptDialog() }
			{this.renderProductErrorDialog()}
		</div>;
	}

	private renderProductErrorDialog()
	{	
		var errors = this.state.productErrors;
		var errorArray = errors.split(/\r|\n|↵/);
		var errorElements = errorArray.map((error:string) =>{
				if (error !== "")
				{
					return <div>{error}</div>;
				}
				else return null;
		});
		return <ModalDialog title="Error Occurred" open={this.state.isErrorDialogOpen}>
			<ModalBody>
				The following products have been removed from your basket:
				<div>
					{errorElements}
				</div>
			</ModalBody>
			<ModalFooter>
				<Button label="Close" className="muted" onClick={() =>
                {
					this.closeErrorDialog();
                } }/>
			</ModalFooter>
		</ModalDialog>;
	}

	private renderShoppingBasket()
	{
		if (this.state.isCheckingout)
		{
			return null;
		}
		return <div>
			<h1>{ this.props.cartTitle }</h1>
			<CartViewer
				shoppingBasket={this.state.shoppingBasket}
				removeLineItem={this.confirmRemoveLineItem.bind(this) }
				adjustLineItemQty={this.adjustLineItemQty.bind(this) }
				gotoCheckout={this.gotoCheckout.bind(this) }
				allowLineItemEdits={ this.props.allowLineItemEdits }
				showShipping={ this.props.showShipping }/>
		</div>;
	}

	private renderCheckout()
	{
		if (!this.state.isCheckingout)
		{
			return null;
		}
		return <div>
			<h1>Checkout</h1>
			<Checkout
				shoppingBasket={this.state.shoppingBasket}
				removeLineItem={this.confirmRemoveLineItem.bind(this) }
				adjustLineItemQty={this.adjustLineItemQty.bind(this) }
				showShipping={this.props.showShipping}
				allowLineItemEdits={this.props.allowLineItemEdits}
				lockShippingAddress={this.props.lockShippingAddress}
				hidePONumber={this.props.hidePONumber}
				termsLink={this.props.termsLink}
				skipRedirectToOrderConfirmation={this.props.skipRedirectToOrderConfirmation}
				shippingRequiresPhoneNumber={this.props.shippingRequiresPhoneNumber}
				billingRequiresPhoneNumber={this.props.billingRequiresPhoneNumber}
				onCheckoutSuccess={this.props.onCheckoutSuccess}
				isAnonEnabled={this.state.shoppingBasket.configuration.isAnonymousCheckoutEnabled}
				/>
		</div>;
	}

	private renderRemoveItemDialog()
	{
		if (this.state.removingLineItem == null)
		{
			return null;
		}

		return <ModalDialog title="Remove Item" open={this.state.isRemoveItemDialogOpen}>
			<ModalBody>
				Are you sure you want to remove item {this.state.removingLineItem.product.name}
			</ModalBody>
			<ModalFooter>
				<Button label="Remove Item" onClick={() =>
                {
					this.removeLineItem();
                } }/>
				<Button label="Cancel" className="muted" onClick={() =>
                {
					this.showRemoveItemDialog(false);
                } }/>
			</ModalFooter>
		</ModalDialog>;
	}

	private renderLoginPromptDialog()
	{
		return <ModalDialog title="Login Required" open={this.state.isLogonCheckDialogOpen}>
			<ModalBody>
				You must be logged in to checkout.Redirecting you to the login page now.
			</ModalBody>
			<ModalFooter>
				<Button label="Proceed to Login" onClick={() =>
                {
					this.redirectToLogon();
                } }/>
				<Button label="Cancel" className="muted" onClick={() =>
                {
					this.showLoginPromptDialog(false);
                } }/>
			</ModalFooter>
		</ModalDialog>;
	}
}


// WEBPACK FOOTER //
// ./src/components/shoppingbasket/ShoppingBasket.tsx